// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__cnesV","header":"Messages_header__38Fs7"};